export const connectionName = 'Schowalter Ltd'

export const connectionNode = {
  id: '9f7e3ccb-ec6c-4922-8a45-5993a816436a',
  ourDid: 'GFUdCdxMPPvaxZPXFoybklCGO',
  theirDid: 'hFMwUXaWNBJSvGNwtKtvxTkdf',
  theirEndpoint: 'http://DwcpVQN.com/ZowrgMH.php',
  theirLabel: connectionName,
  createdMs: '1615461608140',
  approvedMs: '',
  invited: true,
  events: null,
  __typename: 'Pairwise',
}

export const connections = {
  edges: [
    {
      cursor: 'UGFpcndpc2U6MTYxNTQ2MTYwODE0MA==',
      node: connectionNode,
      __typename: 'PairwiseEdge',
    },
  ],
  pageInfo: {
    endCursor: 'UGFpcndpc2U6MTYxNTQ2MTYwODE0MA==',
    startCursor: 'UGFpcndpc2U6MTYxNTQ2MTYwODE0MA==',
    hasPreviousPage: false,
    hasNextPage: false,
    __typename: 'PageInfo',
  },
  __typename: 'PairwiseConnection',
}

export const events = {
  edges: [
    {
      cursor: 'RXZlbnQ6MTYxNTQ2MTYwODE3Mg==',
      node: {
        id: 'c369687c-d2dc-4039-b4e7-f7b82727b316',
        read: false,
        description: 'Accusantium consequatur perferendis voluptatem sit aut.',
        createdMs: '1615461608171',
        connection: connectionNode,
        __typename: 'Event',
        job: {
          node: {
            id: '4344f125-4dd6-4af5-8606-190d33f2e91c',
            protocol: 'NONE',
            initiatedByUs: false,
            status: 'COMPLETE',
            result: 'SUCCESS',
            createdMs: '1615461608165',
            updatedMs: '-8657286238070',
            output: {
              connection: null,
              message: null,
              credential: null,
              proof: null,
              __typename: 'JobOutput',
            },
            __typename: 'Job',
          },
          cursor: 'Sm9iOjE2MTU0NjE2MDgxNjU=',
          __typename: 'JobEdge',
        },
      },
      __typename: 'EventEdge',
    },
    {
      cursor: 'RXZlbnQ6MTYxNTU1MjY3MTI4MQ==',
      node: {
        id: '6a03c370-714d-423f-b865-a7edb6861d2f',
        read: false,
        description: 'Received credential offer',
        createdMs: '1615552671280',
        connection: {
          id: '9f7e3ccb-ec6c-4922-8a45-5993a816436a',
          theirLabel: 'Schowalter Ltd',
          __typename: 'Pairwise',
        },
        __typename: 'Event',
        job: {
          node: {
            id: 'b3e783ff-2e94-4f29-be37-de550cc38d0f',
            protocol: 'CREDENTIAL',
            initiatedByUs: false,
            status: 'COMPLETE',
            result: 'SUCCESS',
            createdMs: '1615552671280',
            updatedMs: '1615552672281',
            output: {
              connection: null,
              message: null,
              credential: {
                cursor: 'Q3JlZGVudGlhbDoxNjE1NTUyNjcxMjgx',
                node: {
                  id: '1be44663-b058-4d08-b72c-74b59a865998',
                  role: 'HOLDER',
                  schemaId: 'vHbvlrcIKKIRyWeJqdSCdjuus',
                  credDefId: 'credDefId3',
                  attributes: [
                    {
                      id: 'f4c51e47-495a-41dc-b934-bf7fa2e3051d',
                      name: 'name1',
                      value: 'value1',
                      __typename: 'CredentialValue',
                    },
                    {
                      id: '28726bde-c1aa-410c-861f-bafc1175d9f3',
                      name: 'name2',
                      value: 'value2',
                      __typename: 'CredentialValue',
                    },
                    {
                      id: '50d8bbbb-4b5f-4163-80b7-ee0308020ba3',
                      name: 'name3',
                      value: 'value3',
                      __typename: 'CredentialValue',
                    },
                  ],
                  initiatedByUs: true,
                  createdMs: '1615552671280',
                  approvedMs: '1615552672280',
                  issuedMs: '1615552672280',
                  __typename: 'Credential',
                },
                __typename: 'CredentialEdge',
              },
              proof: null,
              __typename: 'JobOutput',
            },
            __typename: 'Job',
          },
          cursor: 'Sm9iOjE2MTU1NTI2NzEyODE=',
          __typename: 'JobEdge',
        },
      },
      __typename: 'EventEdge',
    },
    {
      cursor: 'RXZlbnQ6MTYxNTU1MjY3MjI4MQ==',
      node: {
        id: 'e1d31f0f-3871-49e3-bf73-cd8208bf4269',
        read: false,
        description: 'Received credential',
        createdMs: '1615552672281',
        connection: {
          id: '9f7e3ccb-ec6c-4922-8a45-5993a816436a',
          theirLabel: 'Schowalter Ltd',
          __typename: 'Pairwise',
        },
        __typename: 'Event',
        job: {
          node: {
            id: 'b3e783ff-2e94-4f29-be37-de550cc38d0f',
            protocol: 'CREDENTIAL',
            initiatedByUs: false,
            status: 'COMPLETE',
            result: 'SUCCESS',
            createdMs: '1615552671280',
            updatedMs: '1615552672281',
            output: {
              connection: null,
              message: null,
              credential: {
                cursor: 'Q3JlZGVudGlhbDoxNjE1NTUyNjcxMjgx',
                node: {
                  id: '1be44663-b058-4d08-b72c-74b59a865998',
                  role: 'HOLDER',
                  schemaId: 'vHbvlrcIKKIRyWeJqdSCdjuus',
                  credDefId: 'credDefId3',
                  attributes: [
                    {
                      id: 'f4c51e47-495a-41dc-b934-bf7fa2e3051d',
                      name: 'name1',
                      value: 'value1',
                      __typename: 'CredentialValue',
                    },
                    {
                      id: '28726bde-c1aa-410c-861f-bafc1175d9f3',
                      name: 'name2',
                      value: 'value2',
                      __typename: 'CredentialValue',
                    },
                    {
                      id: '50d8bbbb-4b5f-4163-80b7-ee0308020ba3',
                      name: 'name3',
                      value: 'value3',
                      __typename: 'CredentialValue',
                    },
                  ],
                  initiatedByUs: true,
                  createdMs: '1615552671280',
                  approvedMs: '1615552672280',
                  issuedMs: '1615552672280',
                  __typename: 'Credential',
                },
                __typename: 'CredentialEdge',
              },
              proof: null,
              __typename: 'JobOutput',
            },
            __typename: 'Job',
          },
          cursor: 'Sm9iOjE2MTU1NTI2NzEyODE=',
          __typename: 'JobEdge',
        },
      },
      __typename: 'EventEdge',
    },
    {
      cursor: 'RXZlbnQ6MTYxNTU1MjcwNjkwMw==',
      node: {
        id: '9443fe66-9935-4ec0-82f3-b0f27c323bd2',
        read: false,
        description: 'Received proof request',
        createdMs: '1615552706903',
        connection: {
          id: '9f7e3ccb-ec6c-4922-8a45-5993a816436a',
          theirLabel: 'Schowalter Ltd',
          __typename: 'Pairwise',
        },
        __typename: 'Event',
        job: {
          node: {
            id: '9306e30c-ae20-4d73-88a0-02407edb32c1',
            protocol: 'PROOF',
            initiatedByUs: false,
            status: 'COMPLETE',
            result: 'SUCCESS',
            createdMs: '1615552706903',
            updatedMs: '1615552707904',
            output: {
              connection: null,
              message: null,
              credential: null,
              proof: {
                cursor: 'UHJvb2Y6MTYxNTU1MjcwNjkwMw==',
                node: {
                  id: '1f709bef-96ed-4d06-820d-0c5a06f79c46',
                  role: 'PROVER',
                  attributes: [
                    {
                      id: '0636e74a-01be-45aa-9194-9bf9b6f4d783',
                      name: 'name1',
                      credDefId: 'credDefId1',
                      __typename: 'ProofAttribute',
                    },
                    {
                      id: '8a773593-6909-4b52-8179-bee3f61e6893',
                      name: 'name2',
                      credDefId: 'credDefId2',
                      __typename: 'ProofAttribute',
                    },
                    {
                      id: 'a342a1d7-6833-428e-8c97-c1d46c6f2a72',
                      name: 'name3',
                      credDefId: 'credDefId3',
                      __typename: 'ProofAttribute',
                    },
                  ],
                  initiatedByUs: false,
                  result: false,
                  createdMs: '1615552706903',
                  approvedMs: '1615552707903',
                  verifiedMs: '1615552707903',
                  values: [
                    {
                      attributeId: 'id1',
                      value: '',
                      __typename: 'ProofValue',
                    },
                  ],
                  provable: { provable: false, __typename: 'Provable' },
                  __typename: 'Proof',
                },
                __typename: 'ProofEdge',
              },
              __typename: 'JobOutput',
            },
            __typename: 'Job',
          },
          cursor: 'Sm9iOjE2MTU1NTI3MDY5MDM=',
          __typename: 'JobEdge',
        },
      },
      __typename: 'EventEdge',
    },
    {
      cursor: 'RXZlbnQ6MTYxNTU1MjcwNzkwNA==',
      node: {
        id: '7bd1c0f8-cf98-469b-b031-bfd5cc52530a',
        read: false,
        description: 'Proved credential',
        createdMs: '1615552707904',
        connection: {
          id: '9f7e3ccb-ec6c-4922-8a45-5993a816436a',
          theirLabel: 'Schowalter Ltd',
          __typename: 'Pairwise',
        },
        __typename: 'Event',
        job: {
          node: {
            id: '9306e30c-ae20-4d73-88a0-02407edb32c1',
            protocol: 'PROOF',
            initiatedByUs: false,
            status: 'COMPLETE',
            result: 'SUCCESS',
            createdMs: '1615552706903',
            updatedMs: '1615552707904',
            output: {
              connection: null,
              message: null,
              credential: null,
              proof: {
                cursor: 'UHJvb2Y6MTYxNTU1MjcwNjkwMw==',
                node: {
                  id: '1f709bef-96ed-4d06-820d-0c5a06f79c46',
                  role: 'PROVER',
                  attributes: [
                    {
                      id: '0636e74a-01be-45aa-9194-9bf9b6f4d783',
                      name: 'name1',
                      credDefId: 'credDefId1',
                      __typename: 'ProofAttribute',
                    },
                    {
                      id: '8a773593-6909-4b52-8179-bee3f61e6893',
                      name: 'name2',
                      credDefId: 'credDefId2',
                      __typename: 'ProofAttribute',
                    },
                    {
                      id: 'a342a1d7-6833-428e-8c97-c1d46c6f2a72',
                      name: 'name3',
                      credDefId: 'credDefId3',
                      __typename: 'ProofAttribute',
                    },
                  ],
                  initiatedByUs: false,
                  result: false,
                  createdMs: '1615552706903',
                  approvedMs: '1615552707903',
                  verifiedMs: '1615552707903',
                  values: [
                    {
                      attributeId: 'id1',
                      value: '',
                      __typename: 'ProofValue',
                    },
                  ],
                  provable: { provable: false, __typename: 'Provable' },
                  __typename: 'Proof',
                },
                __typename: 'ProofEdge',
              },
              __typename: 'JobOutput',
            },
            __typename: 'Job',
          },
          cursor: 'Sm9iOjE2MTU1NTI3MDY5MDM=',
          __typename: 'JobEdge',
        },
      },
      __typename: 'EventEdge',
    },
    {
      cursor: 'RXZlbnQ6MTYxNTU1MjcxMjA2Nu==',
      node: {
        id: '195b53c2-8331-4442-a241-9b4121f7a171',
        read: false,
        description: 'Sent basic message',
        createdMs: '1615552712067',
        connection: {
          id: '9f7e3ccb-ec6c-4922-8a45-5993a816436a',
          theirLabel: 'Schowalter Ltd',
          __typename: 'Pairwise',
        },
        __typename: 'Event',
        job: {
          node: {
            id: 'c28385d0-075a-42f3-9e76-3e3bffdbac11',
            protocol: 'BASIC_MESSAGE',
            initiatedByUs: false,
            status: 'COMPLETE',
            result: 'SUCCESS',
            createdMs: '1615552712067',
            updatedMs: '-6795364578871',
            output: {
              connection: null,
              message: {
                cursor: 'QmFzaWNNZXNzYWdlOjE2MTU1NTI3MTIwNjc=',
                node: {
                  id: '60bfde0e-3a3d-4e5d-be86-b76d32f0b0a3',
                  message:
                    'Accept',
                  sentByMe: true,
                  delivered: null,
                  createdMs: '1615552712067',
                  __typename: 'BasicMessage',
                },
                __typename: 'BasicMessageEdge',
              },
              credential: null,
              proof: null,
              __typename: 'JobOutput',
            },
            __typename: 'Job',
          },
          cursor: 'Sm9iOjE2MTU1NTI3MTIwNjc=',
          __typename: 'JobEdge',
        },
      },
      __typename: 'EventEdge',
    },
    {
      cursor: 'RXZlbnQ6MTYxNTU1MjcxMjA2Nw==',
      node: {
        id: '195b53c2-8331-4442-a241-9b4121f7a170',
        read: false,
        description: 'Received basic message',
        createdMs: '1615552712067',
        connection: {
          id: '9f7e3ccb-ec6c-4922-8a45-5993a816436a',
          theirLabel: 'Schowalter Ltd',
          __typename: 'Pairwise',
        },
        __typename: 'Event',
        job: {
          node: {
            id: 'c28385d0-075a-42f3-9e76-3e3bffdbac10',
            protocol: 'BASIC_MESSAGE',
            initiatedByUs: false,
            status: 'COMPLETE',
            result: 'SUCCESS',
            createdMs: '1615552712067',
            updatedMs: '-6795364578871',
            output: {
              connection: null,
              message: {
                cursor: 'QmFzaWNNZXNzYWdlOjE2MTU1NTI3MTIwNjc=',
                node: {
                  id: '60bfde0e-3a3d-4e5d-be86-b76d32f0b0a3',
                  message:
                    'Hello! I\'m Credential Service for Findy. I can issue credentials for you. First, I would like to establish connection',
                  sentByMe: false,
                  delivered: null,
                  createdMs: '1615552712067',
                  __typename: 'BasicMessage',
                },
                __typename: 'BasicMessageEdge',
              },
              credential: null,
              proof: null,
              __typename: 'JobOutput',
            },
            __typename: 'Job',
          },
          cursor: 'Sm9iOjE2MTU1NTI3MTIwNjc=',
          __typename: 'JobEdge',
        },
      },
      __typename: 'EventEdge',
    },
  ],
  pageInfo: {
    endCursor: 'RXZlbnQ6MTYxNTU1MjcxMjA2Nw==',
    startCursor: 'RXZlbnQ6MTYxNTQ2MTYwODE3Mg==',
    hasPreviousPage: false,
    hasNextPage: false,
    __typename: 'PageInfo',
  },
  __typename: 'EventConnection',
}
